import { useState, useEffect } from "react";
import "./TypeText.scss";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const TypeText = ({
  text,
  delay,
  renderHtml = false,
  needScroll = true,
  setIsStreaming,
  scrollToBottom,
  type = false,
  status = null,
  isStreaming = true,
}) => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  // Typing logic goes here
  useEffect(() => {
    if (isStreaming) {
      if (currentIndex < text.length) {
        const timeout = setTimeout(() => {
          setCurrentText((prevText) => prevText + text[currentIndex]);
          setCurrentIndex((prevIndex) => prevIndex + 1);
          if (currentIndex + 1 == text?.length) {
            setIsStreaming(false);
          }
          if (needScroll) {
            scrollToBottom();
          }
        }, delay);

        return () => clearTimeout(timeout);
      }
    } else {
      setIsStreaming();
    }
  }, [currentIndex, delay, text, isStreaming]);
  return renderHtml ? (
    <>
      <span
        dangerouslySetInnerHTML={{
          __html: type
            ? currentText + '<span className="blinking-cursor">|</span>'
            : currentText,
        }}
      ></span>
    </>
  ) : (
    <>
      <span className={`${type ? "message" : ""}`}>
        <ReactMarkdown
          children={`${currentText} <span className="blinking-cursor">|</span>`}
          rehypePlugins={[rehypeRaw]}
          remarkPlugins={[remarkGfm]}
        />
        {/* <span className="blinking-cursor">|</span> */}
      </span>
    </>
  );
};

export default TypeText;
